<template> 
	<div v-if="!optionalClass">
		<slot name="icon" v-if="hasIcon">icon</slot>
		<slot name="selectLabel" v-if="hasLabel">selectLabel</slot>
		<slot name="singleSelectMain">singleSelectMain</slot>
		<slot name="selectButton" v-if="hasButton">selectButton</slot>
	</div>
	<div v-else :class="optionalClass">
		<slot name="icon" v-if="hasIcon">icon</slot>
		<slot name="selectLabel" v-if="hasLabel">selectLabel</slot>
		<slot name="singleSelectMain">singleSelectMain</slot>
		<slot name="selectButton" v-if="hasButton">selectButton</slot>
	</div>
</template>
<script>
	export default {
        name: 'singleSelect',
        props: ['hasIcon', 'hasLabel', 'optionalClass', 'hasButton']
    }
</script>